import script from "./DownLoadDetailDispBase.vue?vue&type=script&setup=true&lang=ts"
export * from "./DownLoadDetailDispBase.vue?vue&type=script&setup=true&lang=ts"

import "./DownLoadDetailDispBase.vue?vue&type=style&index=0&id=1b9095e2&lang=scss&scoped=true"

import exportComponent from "/home/matriXagent/git/center-secure/product/ap/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b9095e2"]])

export default __exports__